export default __webpack_public_path__ + "static/media/DoorHangerFlyer.b32322bd.eps";